import React, { useMemo } from 'react';

import { CustomIcon, Paper } from '@components';

import styles from './ConfirmPageOrderStatusElement.module.scss';
import { MyCheckApp, useNavigation, useTranslation } from 'mycheck-core';

export const ConfirmPageOrderStatusElement = ({
  guestOrderStatusId,
}: {
  guestOrderStatusId: number;
}) => {
  const { t } = useTranslation();
  const navigation = useNavigation();
  const config = useMemo(() => {
    const _config = MyCheckApp.instance.getGlobalConfig();

    const primaryColor = _config.palette.primary;
    return {
      primaryColor,
    };
  }, [location.search]);

  return (
    <Paper
      className={styles.element}
      onClick={() => navigation.push(`/menu/orderStatus/${guestOrderStatusId}`)}
      testId="order-status-page-element"
    >
      <CustomIcon
        name="survey"
        style={{ width: '40', height: '50', color: config.primaryColor }}
      />
      <div>
        <div className={styles.elementTitle}>
          {t('confirm.orderStatusTitle')}
        </div>
        <div className={styles.elementValue}>
          {t('confirm.orderStatusSubtitle')}
        </div>
      </div>
      <CustomIcon
        name={document.dir === 'rtl' ? 'arrowLeft' : 'arrowRight'}
        className={styles.elementArrow}
        style={{ color: config.primaryColor }}
      />
    </Paper>
  );
};
